export const UploadNetworkError = 'Upload failed due to network error';
export const DownloadNetworkError = 'Download failed due to network error';
